  // Tab toggle
  const tabs = document.querySelectorAll('.cc-tab-toggle button');
  const panels = document.querySelectorAll('.cc-tab-panel');
  tabs.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabs.forEach(t => {
        const active = t.dataset.tab === target;
        t.classList.toggle('cc-is-active', active);
        t.setAttribute('aria-selected', active);
      });
      panels.forEach(p => p.classList.toggle('cc-is-active', p.id === 'tab-' + target));
      window.scrollTo({ top: document.querySelector('.cc-tab-toggle').offsetTop - 100, behavior: 'smooth' });
    });
  });

  // In-page jump links (data-jump="cameras" etc) — switch tabs and scroll
  document.querySelectorAll('a[data-jump]').forEach(a => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const target = a.dataset.jump;
      const btn = document.querySelector('.cc-tab-toggle button[data-tab="' + target + '"]');
      if (btn) btn.click();
    });
  });

  // ============ Wire-length picker modal ============
  (function() {
    const modal = document.getElementById('wire-modal');
    if (!modal) return;

    const camNameEls = modal.querySelectorAll('[data-wm-cam]');
    const camShortEl = modal.querySelector('[data-wm-cam-short]');
    const runLabel   = modal.querySelector('[data-wm-runlabel]');
    const measText   = modal.querySelector('[data-wm-meas-text]');
    const measSub    = modal.querySelector('[data-wm-meas-sub]');
    const cable      = modal.querySelector('[data-wm-cable]');
    const camera     = modal.querySelector('[data-wm-camera]');
    const measL1     = modal.querySelector('[data-wm-meas-l1]');
    const measR      = modal.querySelector('[data-wm-meas-r]');
    const optionEls  = modal.querySelectorAll('[data-wm-ft]');
    const confirmBtn = modal.querySelector('[data-wm-confirm]');
    const cancelBtn  = modal.querySelector('[data-wm-cancel]');

    let activeFt = null;
    let activeCam = null;
    let activeCamId = null;
    let activeProductUrl = null;
    let activeWireVariants = null;

    function updateDiagram(ft) {
      // Matches the WireRunDiagram math: outletX=56, camX = 150 + t*180 (150→330)
      const fmin = 25, fmax = 125;
      const safe = typeof ft === 'number' ? ft : 50;
      const t = Math.min(1, Math.max(0, (safe - fmin) / (fmax - fmin)));
      const outletX = 56;
      const camX = 150 + t * 180;
      const sag = 14 + t * 30;
      const xStart = 74;
      const xEnd = camX - 22;
      const mid = (xStart + xEnd) / 2;
      // Cable path
      cable.setAttribute('d', `M ${xStart} 107 C ${mid - 24} ${107 + sag}, ${mid + 24} ${107 + sag}, ${xEnd} 99`);
      // Camera group (origin at center of dome, translate to (camX, 96))
      camera.setAttribute('transform', `translate(${camX} 96)`);
      // Dimension line + labels
      measL1.setAttribute('x2', camX);
      measR.setAttribute('x1', camX);
      measR.setAttribute('x2', camX);
      const midX = (outletX + camX) / 2;
      measText.setAttribute('x', midX);
      measText.textContent = typeof ft === 'number' ? (ft + ' FT') : '—';
      if (measSub) measSub.setAttribute('x', midX);
    }

    function setFt(ft) {
      activeFt = ft;
      optionEls.forEach(b => b.classList.toggle('cc-is-selected', String(b.dataset.wmFt) === String(ft)));
      const numeric = typeof ft === 'number';
      runLabel.textContent = numeric ? `${ft} feet` : '—';
      updateDiagram(ft);
      confirmBtn.disabled = ft == null;
      confirmBtn.style.opacity = ft == null ? 0.5 : 1;
      confirmBtn.style.pointerEvents = ft == null ? 'none' : 'auto';
    }

    function applyWireData(map) {
      optionEls.forEach(b => {
        const entry = map ? map[b.dataset.wmFt] : null;
        b.hidden = !!map && !entry;
        if (entry) {
          const priceEl = b.querySelector('[data-wm-price]');
          if (priceEl) priceEl.textContent = entry.price;
        }
      });
    }

    function openModal(camName, camId, productUrl, wireVariantsJson) {
      activeCam = camName;
      activeCamId = camId || null;
      activeProductUrl = productUrl || null;
      activeWireVariants = null;
      if (wireVariantsJson) {
        try { activeWireVariants = JSON.parse(wireVariantsJson); } catch (e) { activeWireVariants = null; }
      }
      applyWireData(activeWireVariants);
      camNameEls.forEach(el => el.textContent = camName);
      if (camShortEl) camShortEl.textContent = camName;
      setFt(null);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      activeCam = null;
      activeCamId = null;
      activeProductUrl = null;
      activeWireVariants = null;
      activeFt = null;
    }

    function confirmSelection() {
      if (activeFt == null || !activeCam) return;
      try { sessionStorage.setItem('cc_pending_pick', JSON.stringify({ cam: activeCam, camId: activeCamId, wire: activeFt, ts: Date.now() })); } catch(e){}
      // After the wire-length pick, send them on to that camera's real product page,
      // with the matching cable-length variant pre-selected if we have it.
      if (!activeProductUrl) return;
      let url = activeProductUrl;
      const entry = activeWireVariants && activeWireVariants[String(activeFt)];
      if (entry && entry.id) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + entry.id;
      window.location.href = url;
    }

    optionEls.forEach(b => {
      b.addEventListener('click', () => {
        const raw = b.dataset.wmFt;
        setFt(parseInt(raw, 10));
        confirmSelection();
      });
    });

    cancelBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => { if (!modal.hidden && e.key === 'Escape') closeModal(); });

    confirmBtn.addEventListener('click', confirmSelection);

    // Wire up camera-card buttons that still need a wire-length pick before
    // heading to the camera's product page (standalone cameras and Remote
    // Location Add-On kits both ship with a cable, so both get the picker;
    // the 4MP cam is a flat-priced single SKU and adds straight to cart
    // instead, see .cc-add-to-cart below).
    function bindCameraCards(scopeId) {
      const scope = document.getElementById(scopeId);
      if (!scope) return;
      scope.querySelectorAll('.cc-prod-card').forEach(card => {
        if (card.hasAttribute('data-no-wire-modal')) return;
        const link = card.querySelector('.cc-pricerow a');
        if (!link || link.classList.contains('cc-add-to-cart')) return;
        const camName = (card.querySelector('h4') || {}).textContent || 'this camera';
        const camId = card.dataset.camId || null;
        const productUrl = card.dataset.productUrl || null;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          openModal(camName.trim(), camId, productUrl, card.dataset.wireVariants);
        });
      });
    }
    bindCameraCards('tab-cameras');
    bindCameraCards('tab-addons');
  })();

  // ============ Direct add-to-cart (flat-priced single-SKU parts) ============
  document.querySelectorAll('.cc-add-to-cart').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = link.dataset.variantId;
      if (!variantId) {
        alert("This item isn't connected to checkout yet. Call (605) 622-0676 to order it directly.");
        return;
      }
      const original = link.textContent;
      link.textContent = 'Adding…';
      link.style.pointerEvents = 'none';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then((r) => (r.ok ? r.json() : r.json().then((e) => { throw e; })))
        .then(() => fetch('/cart.js').then((r) => r.json()))
        .then((cart) => {
          let badge = document.querySelector('.cc-nav-cart-count');
          if (!badge) {
            const cartLink = document.querySelector('.cc-nav-cart');
            if (cartLink) {
              badge = document.createElement('span');
              badge.className = 'cc-nav-cart-count';
              cartLink.appendChild(badge);
            }
          }
          if (badge) badge.textContent = cart.item_count;
          link.textContent = 'Added ✓';
          setTimeout(() => {
            link.textContent = original;
            link.style.pointerEvents = '';
          }, 1800);
        })
        .catch((err) => {
          console.error('Add to cart failed', err);
          alert("Couldn't add this to your cart. Please try again, or call (605) 622-0676.");
          link.textContent = original;
          link.style.pointerEvents = '';
        });
    });
  });

  // ============ Kit variant selectors (Premade Kits tab) ============
  // Multi-variant kits (1/2/3 Location) show a <select>; changing it drives the
  // card's displayed price and the variant the add-to-cart button will add.
  document.querySelectorAll('.cc-kit-variant').forEach((sel) => {
    const card = sel.closest('.cc-prod-card');
    if (!card) return;
    const btn = card.querySelector('.cc-add-to-cart');
    const px = card.querySelector('.cc-pricerow .cc-px');
    sel.addEventListener('change', () => {
      const opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (btn) btn.dataset.variantId = opt.value;
      if (px && opt.dataset.price) px.textContent = opt.dataset.price;
    });
  });
